// extracted by mini-css-extract-plugin
export default {"content":"style_content__h8zhF","checkbox":"style_checkbox__ip1kq"};